import React from "react";
import ReactDOM from "react-dom/client";
import { Provider as ReduxProvider } from "react-redux";
import App from "./App";
import { AuthProvider } from "./auth/JwtContext";
import { store } from "./redux/store";
import reportWebVitals from "./reportWebVitals";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <ReduxProvider store={store}>
    <AuthProvider>
      <App />
    </AuthProvider>
  </ReduxProvider>
);

reportWebVitals();
